module.exports = __webpack_public_path__ + "img/facilities_03.428755d9.jpg";